export interface ApplicationInfoOVP {
  appId: string
  appName: string
  appVersion: string
  browserName: string
  browserVersion: string
  osName: string
  osVersion: string
  userAgent: string
  contentProviderId?: string
}
export enum PlayerEventTypeOVP {
  mute = `mute`,
  unmute = 'unmute',
  subtitle_change = 'subtitle_change',
  rewind = 'rewind',
  openEpg = 'open_channel_epg',
  openChannelList = 'open_channel_list',
  fullScreen = 'full_screen',
  minimizedView = 'minimized_view',
  openEpisodeList = 'episode_list',
  switchToLive = 'switch_to_live',
  fullscreenButtonClick = 'fullscreen_button_click',
  programDetails = 'program_details',
}

export enum PlaybackTriggerEnum {
  playerOpen = 'player_open',
  playButton = 'play_button',
  nextChannel = 'next_channel',
  prevChannel = 'previous_channel',
  selectChannelFromList = 'channel_list',
  channelGrid = 'channel_grid',
  channelDetails = 'channel_details',
  epgList = 'epg_list',
  switchToLive = 'switch_to_live',
  nextEpisode = 'next_episode',
  episodeList = 'episode_list',
  autoswitch = 'autoswitch',
  rewind = 'rewind',
}

export enum FullscreenTypeEnum {
  minimizedPlayer = 'minimized_player',
  fullscreenPlayer = 'fullscreen_player',
  nativeFullscreen = 'native_fullscreen_player',
  pageFullscreen = 'page_fullscreen_player',
}

export interface VideoSourceInfoOVP {
  // all not generic analytics params
  contentId?: string
  contentUrl?: string
  contentType?: string
  contentTitle?: string
  contentStart?: string
  audioLanguage?: string
  textLanguage?: string
  startedTime?: string // read as 'event happened time'
  stoppedTime?: string // read as 'event happened time'
  duration?: string
  publisherId?: string
  playerSessionId?: string
  playerEventType?: PlayerEventTypeOVP
  programTitle?: string
  programStart?: string
  playbackStartTrigger?: PlaybackTriggerEnum
  categoryTitle?: string
  episodeId?: string
  episodeCode?: string
  regionTitle?: string
  watchId?: string
  fullscreenType?: FullscreenTypeEnum
  cmcdSessionId?: string
  errorCode?: string
  errorCodeUI?: string
  errorMessage?: string
}

type WindowSessionGuidType = { windowSessionGuid: string }

export interface IUTMParams {
  utm_source?: string | null
  utm_medium?: string | null
  utm_campaign?: string | null
  utm_term?: string | null
  utm_content?: string | null
}

// TODO: add other paths step by step
export enum AnalyticsPathEnum {
  moviesCategories = '/movies/categories',
  moviesCategory = '/movies/category',
  moviesLanguages = '/languages/movies',
  moviesCategoryLanguage = '/movies/category/language',
  tvshowsCategories = '/tvshows/categories',
  tvshowsCategory = '/tvshows/category',
  tvshowsLanguages = '/languages/tvshows',
  tvshowsCategoryLanguage = '/tvshows/category/language',
  liveCategories = '/live/categories',
  preferences = '/preferences',
}

export interface IURLData {
  path?: AnalyticsPathEnum
  entityId?: string
}

export interface AnalyticsInfoOVP
  extends VideoSourceInfoOVP,
    ApplicationInfoOVP,
    BEAnalyticsInfoOVP,
    WindowSessionGuidType,
    IUTMParams,
    IURLData {}

export interface AnalyticsGenericInfoOVP
  extends VideoSourceInfoOVP,
    ApplicationInfoOVP,
    BEAnalyticsInfoOVP,
    WindowSessionGuidType,
    IUTMParams,
    IURLData {}

export type AnalyticsPromoInstallAppBannerStoreDestination =
  | 'app_store'
  | 'google_play_store'
  | 'amazon_store'

export interface BEAnalyticsInfoOVP {
  // data from b.e.
  networkIp: string
  location: string
  contentUserSubscriberId: string // userGuid, get from BE or 'bot'
  contentUserAccountNumber: string
  contentUserProfileId: string
  preferredLanguage: string
}
// for player open
export interface IContentInfoOVP {
  contentId?: string
  contentType?: string
  contentUrl?: string
  contentTitle?: string
  contentOpenFrom?: string
  publisherId?: string
  contentErrorCode?: string
  playerSessionId?: string
  regionTitle?: string
  fullscreenType?: FullscreenTypeEnum
}

export interface IEpgInfoOVP {
  channelId?: string
  channelTitle?: string
  tabId?: string
}

export interface IEpgCategoryInfoOVP {
  categoryId: string
  categoryTitle: string
}

export interface IEpgChannelInfoOVP {
  channelId: string
  channelTitle: string
  channelOrderPosition: string
  categoryId: string
  categoryTitle: string
}

export interface IEpgProgramInfoOVP extends IEpgChannelInfoOVP {
  programTitle: string
  programStart: string
  programEnd: string
  programStatus: string
}

export interface AnalyticsPlayerOpenInfoOVP
  extends ApplicationInfoOVP,
    BEAnalyticsInfoOVP,
    IContentInfoOVP {}

export interface AnalyticsEpgViewInfoOVP
  extends ApplicationInfoOVP,
    BEAnalyticsInfoOVP,
    WindowSessionGuidType,
    IEpgInfoOVP {}

export interface AnalyticsEpgCategoryInfoOVP
  extends ApplicationInfoOVP,
    BEAnalyticsInfoOVP,
    WindowSessionGuidType,
    IEpgCategoryInfoOVP {}

export interface AnalyticsEpgChannelInfoOVP
  extends ApplicationInfoOVP,
    BEAnalyticsInfoOVP,
    WindowSessionGuidType,
    IEpgChannelInfoOVP {}

export interface AnalyticsEpgProgramInfoOVP
  extends ApplicationInfoOVP,
    BEAnalyticsInfoOVP,
    WindowSessionGuidType,
    IEpgProgramInfoOVP {}

export interface ISearchInfoOVP {
  searchInput?: string
  contentSearchType?: string
}
export interface AnalyticsSearchInfoOVP
  extends ApplicationInfoOVP,
    BEAnalyticsInfoOVP,
    ISearchInfoOVP {}

// This enum just contains values to be send to analytics, values ​​can be changed one day according to requirements
export enum AnalyticsContentType {
  movie = 'movie',
  tvshow = 'tvshow',
  live = 'live',
  catchup = 'catchup',
  liveRewind = 'liveRewind',
}
